import TrackerProvider from '@fingo/lib/components/tracker/TrackerProvider';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import HotjarProvider from '@fingo/lib/providers/HotjarProvider';
import Layout from '@fingo/lib/components/layout/Layout';
import AppRoutes from './AppRoutes';
import AppNavbar from './components/layout/AppNavbar';
import RouteImagePreloader from './components/performance/RouteImagePreloader';

const App = () => (
  <Router>
    <RouteImagePreloader />
    {/* Estos providers no se pueden dejar atrás porque usan ruteo */}
    <HotjarProvider>
      <TrackerProvider
        frontendName="user-frontend"
      >
        <Layout
          whiteBGC={[
            '/',
            '/register',
            '/login',
            '/password-recovery',
          ]}
          NavbarComponent={AppNavbar}
        >
          <AppRoutes />
        </Layout>
      </TrackerProvider>
    </HotjarProvider>
  </Router>
);

export default App;
